import { ErrorMessage, Form, Formik } from 'formik'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import * as Yup from 'yup'
import FormikControl from '../../../components/FormikControl'
import Loader from '../../../components/Loader'
import ModelComponent from '../../../components/Modal'
import ReactSelect from '../../../components/ReactSelect'
import TextError from '../../../components/TextError'
import { showToast } from '../../../lib/AllGlobalFunction'
import { _status_ } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _brandImg_ } from '../../../lib/ImagePath'
import { _exception } from '../../../lib/exceptionMessage'

const BrandForm = ({
  loading,
  setLoading,
  initialValues,
  setInitialValues,
  initVal,
  fetchData,
  modalShow,
  setModalShow,
  toast,
  setToast
}) => {
  const SUPPORTED_FORMATS = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'application/pdf'
  ]
  const { userId } = useSelector((state) => state?.user?.userInfo)
  const location = useLocation()

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Please enter brand name'),
    description: Yup.string().required('Please enter description'),
    status: Yup.string()
      .test(
        'nonull',
        'Please select the status',
        (value) => value !== 'undefined'
      )
      .required('Please select the status'),
    logo: Yup.string()
      .test(
        'fileFormat',
        'File formate is not supported, Please use .jpg/.png/.jpeg format support',
        (value) => {
          if (typeof value === 'string') return true
          else {
            return value && SUPPORTED_FORMATS?.includes(value.type)
          }
        }
      )
      .test('fileSize', 'File must be less than 2MB', (value) => {
        if (typeof value === 'string') {
          return true
        } else return value !== undefined && value && value.size <= 2000000
      })
      .required('Image is required')
  })

  const onSubmit = async (values, resetForm) => {
    let dataofForm = {
      Name: values.name,
      Description: values.description,
      Status: values.status,
      FileName: values?.logo ? values?.logo : '',
      Logo: values?.logo?.name ? values?.logo?.name : ''
    }

    if (values?.id) {
      dataofForm = { ...dataofForm, Id: values?.id }
    }

    const submitFormData = new FormData()

    const keys = Object.keys(dataofForm)

    keys.forEach((key) => {
      submitFormData.append(key, dataofForm[key])
    })
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: values?.id ? 'PUT' : 'POST',
        endpoint: `Brand`,
        data: submitFormData,
        oldData: initialValues,
        logData: values,
        location: location?.pathname,
        userId
      })
      setLoading(false)

      if (response?.data?.code === 200) {
        resetForm({ values: '' })
        setModalShow(false)
        fetchData()
      }
      showToast(toast, setToast, response)
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, setErrors, setTouched, resetForm }) => (
        <Form id='mainBrand'>
          <ModelComponent
            show={modalShow}
            modalsize={'md'}
            className='modal-backdrop'
            modeltitle={!initialValues?.id ? 'Create Brand' : 'Update Brand'}
            onHide={() => {
              setModalShow(false)
              resetForm({ values: '' })
            }}
            backdrop={'static'}
            formbuttonid={'mainBrand'}
            submitname={!initialValues?.id ? 'Create' : 'Update'}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            formik={{ values, setFieldValue, setErrors, setTouched, resetForm }}
          >
            {loading && <Loader />}
            <div className='row'>
              <div className='col-md-3'>
                <div className='input-file-wrapper m--cst-filetype mb-3'>
                  <label className='form-label required' htmlFor='logo'>
                    Image
                  </label>
                  <input
                    id='filename'
                    className='form-control'
                    name='logo'
                    type='file'
                    accept='image/jpg, image/png, image/jpeg'
                    onChange={(event) => {
                      const objectUrl = URL.createObjectURL(
                        event.target.files[0]
                      )
                      if (event.target.files[0].type !== '') {
                        setFieldValue('logoUrl', objectUrl)
                      }
                      setFieldValue(
                        'logo',
                        event?.target?.files[0] ? event?.target?.files[0] : ''
                      )
                    }}
                    hidden
                  />
                  {values?.logo ? (
                    <div className='position-relative m--img-preview d-flex rounded-2 overflow-hidden'>
                      <img
                        src={
                          values?.logoUrl?.includes('blob')
                            ? values?.logoUrl
                            : `${process.env.REACT_APP_IMG_URL}${_brandImg_}${values?.logo}`
                        }
                        alt='Preview Logo'
                        title={values?.logo ? values?.filename?.name : ''}
                        className='rounded-2'
                      ></img>
                      <span
                        onClick={(e) => {
                          setFieldValue('logo', null)
                          setFieldValue('filename', '')
                          document.getElementById('filename').value = null
                        }}
                      >
                        <i className='m-icon m-icon--close'></i>
                      </span>
                    </div>
                  ) : (
                    <>
                      <label
                        className='m__image_default d-flex align-items-center justify-content-center rounded-2'
                        htmlFor='filename'
                      >
                        <i className='m-icon m-icon--defaultpreview'></i>
                      </label>
                    </>
                  )}
                  <ErrorMessage
                    name='logo'
                    component={TextError}
                    customclass={'cfz-12 lh-sm'}
                  />
                </div>
              </div>
              <div className='col-md-9'>
                <div className='row'>
                  <div className='col-md-12'>
                    <FormikControl
                      isRequired
                      control='input'
                      label='Brand Name'
                      type='text'
                      name='name'
                      placeholder='Enter brand name'
                      onChange={(e) => {
                        setFieldValue('name', e?.target?.value)
                      }}
                      onBlur={(e) => {
                        let fieldName = e?.target?.name
                        setFieldValue(fieldName, values[fieldName]?.trim())
                      }}
                    />
                  </div>
                  <div className='col-md-12'>
                    <FormikControl
                      isRequired
                      control='input'
                      label='Description'
                      type='text'
                      name='description'
                      placeholder='Enter description'
                      onBlur={(e) => {
                        let fieldName = e?.target?.name
                        setFieldValue(fieldName, values[fieldName]?.trim())
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='input-select-wrapper mb-3'>
                  <label className='form-label required'>Select Status</label>
                  <ReactSelect
                    id='status'
                    name='status'
                    value={
                      values?.status && {
                        value: values.status,
                        label: values.status
                      }
                    }
                    options={_status_}
                    onChange={(e) => {
                      if (e) {
                        setFieldValue('status', e?.value)
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </ModelComponent>
        </Form>
      )}
    </Formik>
  )
}

export default BrandForm
